import React from "react";
import { Code2, Smartphone, Bot, Compass, ArrowUpRight } from "lucide-react";
import { Reveal, TiltCard } from "../helpers";

const SERVICES = [
  {
    icon: Code2,
    title: "Web Development",
    desc: "Websites for any business, high-converting landing pages, e-commerce and CMS platforms.",
    items: ["Website for Any Business", "E-Commerce", "CMS", "Landing Pages"],
  },
  {
    icon: Smartphone,
    title: "App Development",
    desc: "Beautiful, performant mobile experiences engineered for scale and delight.",
    items: ["Android Apps", "iOS Apps", "Cross-platform", "UI/UX Focused"],
  },
  {
    icon: Bot,
    title: "AI Automation",
    desc: "Intelligent automation that saves time, reduces cost and unlocks new capabilities.",
    items: ["Call Automation", "Workflow Automation", "Text Automation", "AI Chatbots"],
  },
  {
    icon: Compass,
    title: "Digital Consultation",
    desc: "Strategic guidance from requirement gathering to deployment and beyond.",
    items: ["Requirement Gathering", "Business Consultation", "Technology Selection", "Roadmap & Deployment"],
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-28 md:py-32">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[400px] blur-[140px] opacity-10 rounded-full"
        style={{ background: "radial-gradient(circle,#FF8A00,transparent 70%)" }} />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-brand-orange uppercase mb-4">/ Services</p>
          <h2 className="font-heading font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl">
            Everything you need to <span className="text-gradient-orange">build & scale</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <TiltCard
                data-testid={`service-card-${i}`}
                className="gradient-border group h-full rounded-3xl p-8 md:p-10 border border-white/5 hover:-translate-y-2 hover:shadow-[0_20px_60px_-15px_rgba(255,138,0,0.3)] transition-[transform,box-shadow] duration-500"
              >
                <div className="flex items-start justify-between">
                  <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl glass border border-white/10 group-hover:border-brand-orange/40 transition-colors">
                    <s.icon className="h-6 w-6 text-brand-orange group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-xs text-brand-muted">0{i + 1}</span>
                </div>
                <h3 className="mt-6 font-heading font-semibold text-2xl tracking-tight">{s.title}</h3>
                <p className="mt-3 font-body text-brand-sec leading-relaxed">{s.desc}</p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {s.items.map((it) => (
                    <li key={it} className="font-body text-xs text-brand-muted rounded-full border border-white/10 px-3 py-1">
                      {it}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`service-learn-more-${i}`}
                  onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                  className="mt-8 inline-flex items-center gap-1.5 font-body text-sm text-white group-hover:text-brand-orange transition-colors"
                >
                  Learn More
                  <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" strokeWidth={2} />
                </button>
              </TiltCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
